import React, { useContext, useState } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { Link, useNavigate } from "react-router-dom";
import OtherAuth from "../components/OtherAuth";
import { Formik, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import MainHeader from "../components/MainHeader";
import useAxiosRequests from "../hooks/useAxiosRequest";
import ExternalRoutes from "../config/ExternalRoutes";
import AuthContext from "../context/AuthContext";
import { MessageContext } from "../context/MessageContext"; 
import { CircularProgress } from "@mui/material";

export default function Registration() {
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  const { showSuccess, showError } = useContext(MessageContext); 
  const [loading, setLoading] = useState(false);
  
  if (user) navigate("/");

  const schema = Yup.object().shape({
    email: Yup.string()
      .email("Adresse e-mail invalide")
      .required("L'e-mail est requis"),
  });

  const { sendRequest } = useAxiosRequests();

  const onSubmit = async (data) => {
    setLoading(true);

    try {
      const response = await sendRequest({
        method: "POST",
        url: ExternalRoutes.authConfig.inscription,
        body: data,
      });
      
      if (response.status === "success") {
        showSuccess(response.message || "Inscription réussie !");
        navigate("/email-confirmation");
      } else {
        showError(response.message || "Une erreur est survenue.");
        
      }
    } catch (err) {
      showError(err?.message || "Une erreur inattendue est survenue.");
    }finally{
    setLoading(false);

    }
  };

  return (
    <>
      <MainHeader />
      <div className="container">
        {/* Le composant GlobalMessage est déjà inclus dans le layout */}
        <div className="kl-login-page">
          <h1>Créer un compte Comptaride</h1>
          <span>Explorez votre espace personnel</span>
        </div>

        <div className="kl-form-sinup">
          <Formik
            initialValues={{ email: "" }}
            validationSchema={schema}
            onSubmit={onSubmit}
          >
            {({ handleSubmit, isValid, isSubmitting }) => (
              <form
                noValidate
                autoComplete="off"
                className=""
                onSubmit={handleSubmit}
              >
                <div className="mb-4 kl-signup-input">
                  <div className="kl-input-container">
                    <div className="kl-fa-icon">
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M14.167 17.2082H5.83366C4.40774 17.2082 3.35103 16.7997 2.65075 16.0994C1.95047 15.3991 1.54199 14.3424 1.54199 12.9165V7.08317C1.54199 5.65725 1.95047 4.60055 2.65075 3.90027C3.35103 3.19999 4.40774 2.7915 5.83366 2.7915H14.167C15.5929 2.7915 16.6496 3.19999 17.3499 3.90027C18.0502 4.60055 18.4587 5.65725 18.4587 7.08317V12.9165C18.4587 14.3424 18.0502 15.3991 17.3499 16.0994C16.6496 16.7997 15.5929 17.2082 14.167 17.2082ZM5.83366 3.0415C4.5685 3.0415 3.53163 3.34892 2.81552 4.06503C2.09941 4.78115 1.79199 5.81802 1.79199 7.08317V12.9165C1.79199 14.1817 2.09941 15.2185 2.81552 15.9346C3.53164 16.6508 4.5685 16.9582 5.83366 16.9582H14.167C15.4321 16.9582 16.469 16.6508 17.1851 15.9346C17.9012 15.2185 18.2087 14.1817 18.2087 12.9165V7.08317C18.2087 5.81801 17.9012 4.78115 17.1851 4.06503C16.469 3.34892 15.4321 3.0415 14.167 3.0415H5.83366Z"
                          fill="#292D32"
                          stroke="#9CA3AF"
                        />
                        <path
                          d="M8.36595 9.67913L8.36597 9.67911L8.36202 9.67596L5.75588 7.59438C5.69372 7.54298 5.69609 7.46498 5.7297 7.4236C5.78109 7.36036 5.85974 7.36256 5.90135 7.39637L5.90134 7.39638L5.90461 7.39899L8.512 9.48158C8.51216 9.48171 8.51232 9.48184 8.51248 9.48196C8.93375 9.81987 9.47734 9.97289 9.99581 9.97289C10.5143 9.97289 11.0579 9.81987 11.4791 9.48196C11.4793 9.48184 11.4795 9.48171 11.4796 9.48158L14.087 7.39899L14.087 7.399L14.0903 7.39637C14.1445 7.35231 14.2193 7.36783 14.2514 7.41024L14.2566 7.41701L14.2619 7.4236C14.306 7.47783 14.2905 7.55264 14.2481 7.58476L14.248 7.58463L14.2379 7.59263L11.6296 9.67596L11.6296 9.6759L11.6227 9.68155C11.1932 10.0372 10.6033 10.225 9.99998 10.225C9.39752 10.225 8.80565 10.0377 8.36595 9.67913Z"
                          fill="#292D32"
                          stroke="#9CA3AF"
                        />
                      </svg>
                    </div>
                    <Field
                      as={Form.Control}
                      type="email"
                      name="email"
                      className={`kl-input-login ${!isValid && "is-invalid"}`}
                      placeholder="Votre email..."
                      size="lg"
                    />
                  </div>
                  <ErrorMessage
                    name="email"
                    component="small"
                    className="text-danger"
                  />
                </div>

                <div className="kl-button-sinup">
                  <Button
                    type="submit"
                    variant={isValid ? "primary" : "secondary"}
                    disabled={!isValid || loading}
                    className={!isValid ? "kl-button-disabled" : ""}
                  >
                  {
                    loading ? 
                    <>
                      <CircularProgress size={15} color="inherit" />
                    <span className="mx-2">Inscription en cours...</span>
                    </>
                    :
                    "S'inscrire"
                  }
                    {/* {isSubmitting ? "Inscription en cours..." : "S'inscrire"} */}
                  </Button>
                </div>
              </form>
            )}
          </Formik>
        </div>

        <div className="kl-hr-signup">
          <hr />
        </div>

        <div className="kl-other-signup">
          <OtherAuth />
        </div>

        <div className="kl-signup">
          <span>
            Vous possédez déjà un compte?
            <Link to="/login" className="kl-link-page">
              Identifiez-vous
            </Link>
          </span>
        </div>
      </div>
    </>
  );
}